/*******************************************************************************

    Project: Tausend Tassen
    Author: Prima-Line
    Date: XX.XXXX

********************************************************************************

    1. Scroll to top
    2. Off canvas menu
    3. Mobile Menu
    4. Boxes
    5. Footer
    6. Slideshow
    7. Shop Categories
    8. Shop Category
    9. Checkout fields
    10. Fix quantity
    11. EU Cookie

*******************************************************************************/

jQuery( document ).ready(function($) {

/* 1. Scroll to top
------------------------------------------------------------------------------*/

    $(document).on( 'scroll', function(){
        if ($(window).scrollTop() > 200) {
            $('.scroll-to-top').addClass('show');
        } else {
            $('.scroll-to-top').removeClass('show');
        }
    });

    $('.scroll-to-top').on('click', function(event) {
        event.preventDefault();
        var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
        var element = $('body');
        var offset = element.offset();
        var offsetTop = offset.top;
        $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
    });

/* 2. Off canvas menu
------------------------------------------------------------------------------*/

    $('.toggle-nav').click(function() {
        // Calling a function in case you want to expand upon this.
        toggleNav();
    });

    function toggleNav() {
        if ($('#site-wrapper').hasClass('show-nav')) {
            // Do things on Nav Close
            $('#site-wrapper').removeClass('show-nav');
        } else {
            // Do things on Nav Open
            $('#site-wrapper').addClass('show-nav');
        }
    }

    // Fuction for hiding mobile navigation
    function hideNav() {
        if ($('#site-wrapper').hasClass('show-nav')) {
            $('#site-wrapper').removeClass('show-nav');
        }
    }

    // Hide navigation when user pressed Escape key on keyboard
    $(document).keyup(function(e) {
        if (e.keyCode === 27) {
            if ($('#site-wrapper').hasClass('show-nav')) {
                toggleNav();
            }
        }
    });

    // Hide mobile navigation when user increases browser size
    enquire.register("screen and (min-width: 768px)", {
        match : function() {
            hideNav();
        }
    });

/* 3. Mobile Menu
------------------------------------------------------------------------------*/

    $('ul.mob-menu li').has('ul').addClass('parentLi');
    $('ul.mob-menu li ul').addClass('sub-menu');
    $('ul.mob-menu .parentLi').prepend('<a href="#" class="submenu-trigger"></a>');

    $('ul.mob-menu .sub-menu').hide();

    $('ul.mob-menu .parentLi > a.submenu-trigger').on('click', function(event){
        event.preventDefault();
        $(this).toggleClass('expanded');
        $(this).parent().find('ul.sub-menu').slideToggle();
    });

/* 4. Boxes
------------------------------------------------------------------------------*/

    $('.box__inside').matchHeight();
    $('.box__inside h2').matchHeight();

/* 5. Footer
------------------------------------------------------------------------------*/

    $('.site-footer__col').matchHeight();

/* 6. Slideshow
------------------------------------------------------------------------------*/

    $('.slideshow').slick({
        arrows: false,
        dots: true,
        speed: 1100,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5500
    });

    $('.categories-list__in, .slideshow__slide').matchHeight();

/* 7. Shop Categories
------------------------------------------------------------------------------*/

    $('.product-category-link').matchHeight();

/* 8. Shop Category
------------------------------------------------------------------------------*/

    if($('.tax-product_cat').length > 0) {
        $('.product-image-wrap').matchHeight();
        $('.product-title').matchHeight();
        $('.product-description').matchHeight();
        $('.product-wrap').matchHeight();
    }

/* 9. Checkout fields
------------------------------------------------------------------------------*/

    if($('.return-date-field').length > 0) {
        $('.return-date-field').appendTo(".woocommerce-billing-fields");
        $('#return_date').datepicker({
            beforeShowDay: function(date) {
                var day = date.getDay();
                return [(day != 0 && day != 6), ''];
            },
            dateFormat: "dd.mm.y",
            closeText: 'Leeren',
            minDate: +1
        });
    }

if($('.return-slot-field').length > 0) {
        $('.return-slot-field').appendTo(".woocommerce-billing-fields");
    }

/* 10. Fix quantity
------------------------------------------------------------------------------*/

    $('.tax-product_cat .products input[type="number"]').val('1');


/* 11. EU Cookie
/*******************************************************************************/

    // Variables
    var expires_date = new Date('December 31, 2099 23:59:59');
    var cookie_notice_height = $('.cookie-bar').height();

    // Update variables and padding after screen resize
    $(window).on("debouncedresize", function( event ) {
      cookie_notice_height = $('.cookie-bar').height();
      if(!(Cookies.get('eu-cookie-law-tassen') == 'accepted' || Cookies.get('eu-cookie-law-tassen') == 'refused')) {
        $('.site-footer .wrap').css('padding-bottom', cookie_notice_height + 'px');
      }
    });

    // Show cookie notice if it's not configured
    if(Cookies.get('eu-cookie-law-tassen') == 'accepted' || Cookies.get('eu-cookie-law-tassen') == 'refused') {
      $('body').removeClass('cookie-bar--not-decided');
    }
    else {
      $('.site-footer .wrap').css('padding-bottom', cookie_notice_height + 'px');
      $('body').addClass('cookie-bar--not-decided');
    }

    // Hide cookie if it's accepted
    $('.js-accept-cookie').on('click', function(e){
      e.preventDefault();
      Cookies.set('eu-cookie-law-tassen', 'accepted', { expires: expires_date });
      $('body').removeClass('cookie-bar--not-decided');
    });

    // Disable scripts and hide notice
    $('.js-refuse-cookie').on('click', function(e){
      e.preventDefault();
      if(theme_settings.cookie_popup == 1) {
        $.magnificPopup.open({
          items: {
              src: '<div class="white-popup">' + theme_settings.cookie_popup_text + '</div>',
              type: 'inline'
          },
          mainClass: 'mfp-with-fade',
          removalDelay: 160
        });
      }
      else {
        console.log('Tracking scripts and cookies are disabled.');
      }
      Cookies.set('eu-cookie-law-tassen', 'refused', { expires: expires_date });
      // Opt out functions
      // doOptout();
      $('body').removeClass('cookie-bar--not-decided');
    });

});
